export const conditionTypes = ['All', 'Wet', 'Moderate', 'Dry'];



// WEBPACK FOOTER //
// ./src/constants/conditionTypes.js